import test from './components/test';
import mvSlider from './components/mvSlider';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    test();
    mvSlider();
  },
  false,
);
